module.exports = __webpack_public_path__ + "static/media/as2sj.34414fe7.png";